(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["encore-accordions"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ec-accordions').forEach(function (sec) {
    var items = sec.querySelectorAll('.eca-item');
    items.forEach(function (item) {
      var head = item.querySelector('.eca-head');
      var body = item.querySelector('.eca-body');
      if (item.classList.contains('is-open')) { body.style.maxHeight = body.scrollHeight + 'px'; }
      head.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          i.querySelector('.eca-body').style.maxHeight = 0;
          i.querySelector('.eca-head').setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          body.style.maxHeight = body.scrollHeight + 'px';
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });
    window.addEventListener('resize', function () {
      var open = sec.querySelector('.eca-item.is-open .eca-body');
      if (open) { open.style.maxHeight = open.scrollHeight + 'px'; }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["encore-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ec-reviews').forEach(function (sec) {
    var bars = sec.querySelector('.ecr-bars');
    if (!bars) return;
    function fill() {
      bars.querySelectorAll('.ecr-bar__fill').forEach(function (f) {
        f.style.width = (f.getAttribute('data-ec-w') || 0) + '%';
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { fill(); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(bars);
    } else { fill(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["encore-ugc-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ec-ugc .ecu-card.has-video').forEach(function (card) {
    var play = card.querySelector('.ecu-play');
    var video = card.querySelector('.ecu-video');
    if (!play || !video) return;
    play.addEventListener('click', function () {
      card.classList.add('is-playing');
      video.muted = false;
      video.setAttribute('controls', '');
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-encore"] && !Shopify.designMode) return;
  try {
    
(function () {
  function swapHeroToColor(root, color, groupName) {
    if (!color) return;
    var colorLower = color.toLowerCase().trim();
    var groupLower = groupName ? groupName.toLowerCase().trim() : null;
    var matched = null;
    var allThumbs = root.querySelectorAll('.ecmp-thumb');
    var matchingThumbs = [];
    allThumbs.forEach(function (t) {
      var img = t.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '').toLowerCase().trim() : '';
      var isMatch = false;
      if (groupLower && alt.indexOf(' - ') !== -1) {
        var parts = alt.split(' - ');
        var aGroup = parts.shift().trim();
        var aColor = parts.join(' - ').trim();
        isMatch = (aGroup === groupLower && aColor === colorLower);
      } else if (alt.indexOf(colorLower) === 0) {
        var nextChar = alt.charAt(colorLower.length);
        if (nextChar === '' || !/[a-z]/i.test(nextChar)) isMatch = true;
      }
      if (isMatch) {
        matchingThumbs.push(t);
        if (!matched) { matched = t; }
      }
    });
    if (matched) {
      allThumbs.forEach(function (t) {
        if (matchingThumbs.indexOf(t) >= 0) {
          t.classList.remove('is-hidden');
        } else {
          t.classList.add('is-hidden');
        }
      });
      var mid = matched.getAttribute('data-media-id');
      allThumbs.forEach(function (t) { t.classList.remove('is-active'); });
      matched.classList.add('is-active');
      root.querySelectorAll('.ecmp-stage__item').forEach(function (it) {
        it.classList.toggle('is-active', it.getAttribute('data-media-id') === mid);
      });
      if (typeof matched.scrollIntoView === 'function') {
        matched.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }

  function swapHeroToColorSize(root, color, size) {
    var colorLower = color ? color.toLowerCase().trim() : '';
    var sizeLower = size ? size.toLowerCase().trim() : '';
    if (!colorLower && !sizeLower) return;
    var allThumbs = root.querySelectorAll('.ecmp-thumb');
    var matched = null;
    allThumbs.forEach(function (t) {
      if (matched) return;
      var img = t.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '').toLowerCase().trim() : '';
      if (alt.indexOf('|') === -1) return;
      var parts = alt.split('|');
      var aColor = parts[0].trim();
      var aSize = parts[1] ? parts[1].trim() : '';
      var colorOk = !colorLower || aColor === colorLower;
      var sizeOk = !sizeLower || aSize === sizeLower;
      if (colorOk && sizeOk) matched = t;
    });
    if (matched) {
      var mid = matched.getAttribute('data-media-id');
      allThumbs.forEach(function (t) { t.classList.remove('is-active'); });
      matched.classList.add('is-active');
      root.querySelectorAll('.ecmp-stage__item').forEach(function (it) {
        it.classList.toggle('is-active', it.getAttribute('data-media-id') === mid);
      });
      if (typeof matched.scrollIntoView === 'function') {
        matched.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }

  function recomputeGroup(group) {
    var size = parseInt(group.getAttribute('data-pack-size'), 10) || 0;
    var total = 0;
    var pieces = [];
    group.querySelectorAll('.ecmp-pack-swatch').forEach(function (sw) {
      var qtyEl = sw.querySelector('[data-ec-pack-qty]');
      var qty = parseInt(qtyEl.textContent, 10) || 0;
      total += qty;
      if (qty > 0) {
        pieces.push(qty + 'x ' + sw.getAttribute('data-color'));
        sw.classList.add('is-selected');
      } else {
        sw.classList.remove('is-selected');
      }
      var minus = sw.querySelector('[data-ec-pack-step="-1"]');
      if (minus) minus.disabled = (qty <= 0);
    });
    var countEl = group.querySelector('[data-ec-pack-count]');
    if (countEl) countEl.textContent = total;
    var statusEl = group.querySelector('[data-ec-pack-status]');
    if (statusEl) statusEl.textContent = pieces.length ? pieces[0].replace(/^1x /, '') + ' selected' : 'None selected';
    var mixInput = group.querySelector('[data-ec-color-mix]');
    if (mixInput) mixInput.value = pieces.join(', ');
    group.querySelectorAll('[data-ec-pack-step="1"]').forEach(function (btn) {
      btn.disabled = (total >= size);
    });
    group.dataset.complete = (total === size) ? '1' : '0';
  }

  function isGroupActive(group) {
    var shape = group.closest('.ecmp-shape-content');
    return !shape || !shape.hasAttribute('hidden');
  }

  function initPackSystem(root) {
    var groups = root.querySelectorAll('.ecmp-pack-group');
    if (!groups.length) return;
    var packErrorEl = root.querySelector('[data-ec-pack-error]');
    var form = root.querySelector('form.ecmp-form');

    /* Single-select groups: hide the overall Quantity stepper (one set per add) */
    if (root.querySelector('.ecmp-pack-group[data-pack-size="1"]')) {
      var qtyBox = root.querySelector('.ecmp-qty');
      if (qtyBox) {
        qtyBox.style.display = 'none';
        var qtyInput = qtyBox.querySelector('input[name="quantity"]');
        if (qtyInput) qtyInput.value = 1;
        var qtyOpt = qtyBox.closest('.ecmp-opt');
        var qtyLabel = qtyOpt ? qtyOpt.querySelector('.ecmp-opt__label') : null;
        if (qtyLabel && qtyLabel.textContent.trim() === 'Quantity') qtyLabel.style.display = 'none';
      }
    }

    /* Single-select groups: tapping a color row picks it (and unpicks the rest) */
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('.ecmp-pack-swatch');
      if (!sw || !root.contains(sw)) return;
      if (e.target.closest('[data-ec-pack-step]')) return;
      var group = sw.closest('.ecmp-pack-group');
      if (!group || group.getAttribute('data-pack-size') !== '1') return;
      group.querySelectorAll('[data-ec-pack-qty]').forEach(function (q) { q.textContent = '0'; });
      sw.querySelector('[data-ec-pack-qty]').textContent = '1';
      recomputeGroup(group);
      if (packErrorEl) {
        var anyIncomplete = false;
        root.querySelectorAll('.ecmp-pack-group').forEach(function (g) {
          if (isGroupActive(g) && g.dataset.complete !== '1') anyIncomplete = true;
        });
        if (!anyIncomplete) packErrorEl.setAttribute('hidden', '');
      }
      swapHeroToColor(root, sw.getAttribute('data-color'), group.getAttribute('data-pack-group'));
    });

    root.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-ec-pack-step]');
      if (!stepBtn || !root.contains(stepBtn)) return;
      e.preventDefault();
      var group = stepBtn.closest('.ecmp-pack-group');
      if (!group) return;
      var size = parseInt(group.getAttribute('data-pack-size'), 10) || 0;
      var step = parseInt(stepBtn.getAttribute('data-ec-pack-step'), 10);
      var sw = stepBtn.closest('.ecmp-pack-swatch');
      if (!sw) return;
      var qtyEl = sw.querySelector('[data-ec-pack-qty]');
      var current = parseInt(qtyEl.textContent, 10) || 0;
      var otherTotal = 0;
      group.querySelectorAll('.ecmp-pack-swatch').forEach(function (other) {
        if (other === sw) return;
        otherTotal += parseInt(other.querySelector('[data-ec-pack-qty]').textContent, 10) || 0;
      });
      var newVal = current + step;
      if (newVal < 0) newVal = 0;
      if (otherTotal + newVal > size) newVal = size - otherTotal;
      qtyEl.textContent = newVal;
      recomputeGroup(group);
      if (packErrorEl) {
        var anyIncomplete = false;
        root.querySelectorAll('.ecmp-pack-group').forEach(function (g) {
          if (isGroupActive(g) && g.dataset.complete !== '1') anyIncomplete = true;
        });
        if (!anyIncomplete) packErrorEl.setAttribute('hidden', '');
      }
      if (step > 0 && newVal > current) {
        swapHeroToColor(root, sw.getAttribute('data-color'), group.getAttribute('data-pack-group'));
      }
    });

    var shapeRadios = root.querySelectorAll('.ecmp-pack-shape input[type=radio]:not([data-ec-size])');
    function applyShape(idx) {
      root.querySelectorAll('.ecmp-shape-content').forEach(function (sc) {
        var isActive = sc.getAttribute('data-shape-idx') === idx;
        if (isActive) {
          sc.removeAttribute('hidden');
        } else {
          sc.setAttribute('hidden', '');
        }
        sc.querySelectorAll('[data-ec-color-mix]').forEach(function (inp) {
          inp.disabled = !isActive;
        });
      });
      root.querySelectorAll('.ecmp-pack-shape').forEach(function (lbl) {
        var input = lbl.querySelector('input');
        lbl.classList.toggle('is-active', !!(input && input.checked));
      });
      if (packErrorEl) packErrorEl.setAttribute('hidden', '');
    }
    if (shapeRadios.length) {
      shapeRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          applyShape(radio.getAttribute('data-shape-idx'));
        });
      });
      var initiallyChecked = root.querySelector('.ecmp-pack-shape input:checked');
      applyShape(initiallyChecked ? initiallyChecked.getAttribute('data-shape-idx') : '0');
    } else {
      var firstContent = root.querySelector('.ecmp-shape-content');
      if (firstContent) {
        firstContent.removeAttribute('hidden');
        firstContent.querySelectorAll('[data-ec-color-mix]').forEach(function (inp) {
          inp.disabled = false;
        });
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var bad = false;
        root.querySelectorAll('.ecmp-pack-group').forEach(function (g) {
          if (!isGroupActive(g)) return;
          if (g.dataset.complete !== '1') bad = true;
        });
        if (bad) {
          e.preventDefault();
          e.stopPropagation();
          if (packErrorEl) {
            packErrorEl.removeAttribute('hidden');
            if (typeof packErrorEl.scrollIntoView === 'function') {
              packErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
          return false;
        }
      });
    }

    groups.forEach(recomputeGroup);
  }

  function initVariantPicker(root) {
    // Always set up size button visual toggle — no variant data needed
    root.querySelectorAll('[data-ec-size]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var valEl = root.querySelector('[data-ec-sizeval]');
        if (valEl) valEl.textContent = radio.value;
        root.querySelectorAll('[data-ec-size]').forEach(function (r) {
          var lbl = r.closest('.ecmp-pack-shape');
          if (lbl) lbl.classList.toggle('is-active', r === radio);
        });
      });
    });

    // Color + size hero image switching (single-product swatches)
    var ecSingleColors = root.querySelectorAll('.ecmp-swatch input[name="properties[Color]"]');
    var ecSizeRadios = root.querySelectorAll('[data-ec-size]');
    if (ecSingleColors.length || ecSizeRadios.length) {
      var ecGetColor = function () {
        var c = root.querySelector('.ecmp-swatch input[name="properties[Color]"]:checked');
        return c ? c.value : null;
      };
      var ecGetSize = function () {
        var s = root.querySelector('[data-ec-size]:checked');
        return s ? s.value : null;
      };
      var ecUpdateHero = function () {
        swapHeroToColorSize(root, ecGetColor(), ecGetSize());
      };
      ecSingleColors.forEach(function (i) { i.addEventListener('change', ecUpdateHero); });
      ecSizeRadios.forEach(function (i) { i.addEventListener('change', ecUpdateHero); });
    }

    // Variant sync — only if JSON data is present
    var sid = root.id;
    var varEl = document.getElementById(sid + '-ec-variants');
    var optEl = document.getElementById(sid + '-ec-options');
    if (!varEl || !optEl) return;

    var variants, options;
    try {
      variants = JSON.parse(varEl.textContent);
      options = JSON.parse(optEl.textContent);
    } catch (e) { return; }
    if (!variants || !options) return;

    var colorIdx = -1;
    var sizeIdx = -1;
    options.forEach(function (opt, i) {
      var lo = opt.toLowerCase();
      if (lo === 'color') colorIdx = i;
      if (lo === 'size') sizeIdx = i;
    });

    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('.ecmp-add');

    function getSelected(attr) {
      var el = root.querySelector('[data-ec-vopt][name*="' + attr + '"]:checked');
      return el ? el.value : null;
    }

    function syncVariant() {
      var selectedColor = colorIdx >= 0 ? getSelected('Color') : null;
      var selectedSize = sizeIdx >= 0 ? getSelected('Size') : null;

      var match = null;
      variants.forEach(function (v) {
        var colorMatch = colorIdx < 0 || !selectedColor || v['option' + (colorIdx + 1)] === selectedColor;
        var sizeMatch = sizeIdx < 0 || !selectedSize || v['option' + (sizeIdx + 1)] === selectedSize;
        if (colorMatch && sizeMatch && !match) match = v;
      });

      if (match) {
        if (idInput) idInput.value = match.id;
        if (addBtn) {
          var avail = match.available;
          addBtn.textContent = avail ? 'Add to Cart' : 'Sold Out';
          addBtn.disabled = !avail;
        }
      }
    }

    root.querySelectorAll('[data-ec-vopt]').forEach(function (input) {
      input.addEventListener('change', syncVariant);
    });

    syncVariant();
  }

  function initSection(root) {
    if (!root || root.dataset.ecInit === '1') return;
    root.dataset.ecInit = '1';
    initPackSystem(root);
    initVariantPicker(root);

    // Mobile swipe on stage
    var stage = root.querySelector('.ecmp-stage');
    var dotsWrap = root.querySelector('.ecmp-dots');
    if (stage && dotsWrap) {
      var syncDots = function () {
        var act = stage.querySelector('.ecmp-stage__item.is-active');
        var id = act ? act.getAttribute('data-media-id') : null;
        dotsWrap.querySelectorAll('.ecmp-dot').forEach(function (d) {
          d.classList.toggle('is-active', d.getAttribute('data-media-id') === id);
        });
      };
      new MutationObserver(syncDots).observe(stage, { attributes: true, attributeFilter: ['class'], subtree: true });
      syncDots();
    }
    if (stage) {
      var touchStartX = 0;
      var touchStartY = 0;
      var isHSwipe = false;
      stage.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isHSwipe = false;
      }, { passive: true });
      stage.addEventListener('touchmove', function(e) {
        var dx = Math.abs(e.touches[0].clientX - touchStartX);
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > dy && dx > 8) {
          isHSwipe = true;
          e.preventDefault();
        }
      }, { passive: false });
      stage.addEventListener('touchend', function(e) {
        if (!isHSwipe) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) < 40) return;
        var items = root.querySelectorAll('.ecmp-stage__item');
        var thumbs = root.querySelectorAll('.ecmp-thumb');
        var activeIdx = -1;
        items.forEach(function(it, i) { if (it.classList.contains('is-active')) activeIdx = i; });
        var nextIdx = dx < 0
          ? Math.min(activeIdx + 1, items.length - 1)
          : Math.max(activeIdx - 1, 0);
        if (nextIdx === activeIdx) return;
        items.forEach(function(it) { it.classList.remove('is-active'); });
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        items[nextIdx].classList.add('is-active');
        if (thumbs[nextIdx]) thumbs[nextIdx].classList.add('is-active');
      }, { passive: true });
    }
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('.ecmp-thumb');
      if (thumb && root.contains(thumb)) {
        e.preventDefault();
        var id = thumb.getAttribute('data-media-id');
        root.querySelectorAll('.ecmp-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        root.querySelectorAll('.ecmp-stage__item').forEach(function (it) {
          it.classList.toggle('is-active', it.getAttribute('data-media-id') === id);
        });
        return;
      }
      var qtyBtn = e.target.closest('[data-ec-qty]');
      if (qtyBtn && root.contains(qtyBtn)) {
        var qty = root.querySelector('.ecmp-qty input');
        if (qty) {
          var step = parseInt(qtyBtn.getAttribute('data-ec-qty'), 10);
          var val = (parseInt(qty.value, 10) || 1) + step;
          qty.value = val < 1 ? 1 : val;
        }
        return;
      }
      var sw = e.target.closest('.ecmp-swatch');
      if (sw && root.contains(sw)) {
        root.querySelectorAll('.ecmp-swatch').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        var input = sw.querySelector('input');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var valEl = root.querySelector('[data-ec-colorval]');
        if (valEl && input) { valEl.textContent = input.value; }
        if (input && input.value) {
          var color = input.value.trim();
          if (color) {
            var colorLower = color.toLowerCase();
            var matched = null;
            var allThumbs = root.querySelectorAll('.ecmp-thumb');
            var matchingThumbs = [];
            allThumbs.forEach(function (t) {
              var img = t.querySelector('img');
              var alt = img ? (img.getAttribute('alt') || '').toLowerCase().trim() : '';
              if (alt.indexOf(colorLower) === 0) {
                var nextChar = alt.charAt(colorLower.length);
                if (nextChar === '' || !/[a-z]/i.test(nextChar)) {
                  matchingThumbs.push(t);
                  if (!matched) { matched = t; }
                }
              }
            });
            if (matched) {
              allThumbs.forEach(function (t) {
                if (matchingThumbs.indexOf(t) >= 0) {
                  t.classList.remove('is-hidden');
                } else {
                  t.classList.add('is-hidden');
                }
              });
              var mid = matched.getAttribute('data-media-id');
              allThumbs.forEach(function (t) { t.classList.remove('is-active'); });
              matched.classList.add('is-active');
              root.querySelectorAll('.ecmp-stage__item').forEach(function (it) {
                it.classList.toggle('is-active', it.getAttribute('data-media-id') === mid);
              });
              if (typeof matched.scrollIntoView === 'function') {
                matched.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
              }
            }
          }
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.ec-main-product').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? (e.target.querySelector('.ec-main-product') || (e.target.classList && e.target.classList.contains('ec-main-product') ? e.target : null)) : null;
    if (root) { root.dataset.ecInit = ''; initSection(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
